
export { Skeleton } from "/app/packages/ui/src/atoms/skeleton/index.ts"